let config = {
    api_url: "https://webapi.ybt.fi/api", //main
};
  
export default config
